import * as angular from 'angular';
import template from './sqlCounterConfig.tpl.html';

export default angular.module('aps.controller.sqlCounterConfig', [])
  .directive('apsSqlCounterConfig', (): angular.IDirective => {
    return {
      restrict: 'E',
      template: template
    };
  })
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/equipment/sqlCounterConfig.directive.ts